import {
  GET_EVENT_INFO_SUCCESS,
  GET_EVENT_INFO_ERROR,
  GET_GRAND_EVENT_INFO_SUCCESS,
  GET_GRAND_EVENT_INFO_ERROR,
  UPDATE_WEB_VIEW_STATUS
} from '../constants/topShopperConstants';

const initialState = {
  event: {},
  grandEvent: {},
  appWebViewStatus: false
};

export default function topShopperReducer(state = initialState, action) {
  const { type = '', data = {} } = action || {};
  switch (type) {
    case GET_EVENT_INFO_SUCCESS:
      return { ...state, event: { ...data } };
    case GET_EVENT_INFO_ERROR:
      return { ...state, event: {} };
    case GET_GRAND_EVENT_INFO_SUCCESS:
      return { ...state, grandEvent: { ...data } };
    case GET_GRAND_EVENT_INFO_ERROR:
      return { ...state, grandEvent: {} };
    case UPDATE_WEB_VIEW_STATUS:
      return { ...state, ...data };
    default:
      return state;
  }
}
